import { Button as AntButton } from 'antd'
import type { ButtonProps as AntButtonProps } from 'antd'
import { forwardRef } from 'react'
import type { ComponentRef } from 'react'
import { SIZE_MAP } from '../types'
import type { Size } from '../types'

export type AppButtonVariant = 'primary' | 'secondary' | 'dashed' | 'link' | 'text' | 'ghost'

export interface AppButtonProps
  extends Omit<AntButtonProps, 'type' | 'size' | 'block' | 'ghost' | 'variant' | 'color'> {
  variant?: AppButtonVariant
  size?: Size
  fullWidth?: boolean
}

const VARIANT_MAP: Record<AppButtonVariant, Partial<AntButtonProps>> = {
  primary: { type: 'primary' },
  secondary: { type: 'default' },
  dashed: { type: 'dashed' },
  link: { type: 'link' },
  text: { type: 'text' },
  ghost: { type: 'primary', ghost: true }
}

export const AppButton = forwardRef<ComponentRef<typeof AntButton>, AppButtonProps>(
  ({ variant = 'secondary', size = 'md', fullWidth = false, ...rest }, ref) => (
    <AntButton ref={ref} {...VARIANT_MAP[variant]} size={SIZE_MAP[size]} block={fullWidth} {...rest} />
  )
)
